import { render } from "./ReportPagination.vue?vue&type=template&id=0b8bfae5&scoped=true"
import script from "./ReportPagination.vue?vue&type=script&lang=js"
export * from "./ReportPagination.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=0b8bfae5&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8bfae5"]])

export default __exports__